import Script from "next/script"
import { styled } from "styled-system/jsx"

import { ContactFormProps } from "../ContactForm"

type Props = ContactFormProps

function TypeformEmbed({ customForm }: Props) {
  return (
    <styled.div
      css={{
        margin: "-40px -32px",
        rounded: 20,
        overflow: "hidden",
      }}>
      <div data-tf-live={customForm.embedId} />
      <Script
        strategy="afterInteractive"
        src="//embed.typeform.com/next/embed.js"
      />
    </styled.div>
  )
}

export default TypeformEmbed
export type { Props as TypeformEmbedProps }
